import * as React from "react"
import Tooltip from "../../../tooltip"
import * as Model from "../../../../model"

export default class WarningCell
extends React.Component<Props, State> {
	protected eventsAdded = false

	constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
			mouseOver: false,
			mouseMove: null
		}
	}

	componentDidMount() {
		if (this.props.td && !this.eventsAdded) {
			this.props.td.onmousemove = mouseMove => this.setState({ mouseMove })
			this.props.td.onmouseout = () => this.setState({ mouseOver: false })
			this.props.td.onmouseover = () => this.setState({ mouseOver: true })
			this.eventsAdded = true
		}
	}

	render() {
		return <div>
			{this.props.value}
			{this.state.mouseOver
			&& <Tooltip message={this.props.message}
			mouseMove={this.state.mouseMove} />}
		</div>
	}
}

export interface Props {
	cellProperties: any
	col: any
	currentLocalAuthority: Model.LocalAuthority
	message: string
	row: any
	value: any
	td: HTMLTableCellElement
}

interface State {
	mouseOver: boolean
	mouseMove: MouseEvent | null
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/warning-cell.tsx